<script setup>
import { defineProps } from "vue";
defineProps({
  tabs: {
    type: Array,
    required: true,
    validator: (tabs) => {
      return tabs.every((tab) => {
        return ["id", "controls", "isActive"].every((key) => key in tab);
      });
    },
  },
});
</script>

<template>
  <div class="tab-content" id="custom-tabs-one-tabContent">
    <div
      v-for="tab in tabs"
      :key="tab.id"
      class="tab-pane"
      :class="{ 'show active': tab.isActive }"
      :id="tab.controls"
      role="tabpanel"
      :aria-labelledby="tab.id"
    >
      <slot :name="tab.id"></slot>
    </div>
  </div>
</template>

<style scoped>
.tab-pane {
  display: none;
}

.tab-pane.show.active {
  display: block;
}
</style>
